class MainPolicies extends HTMLElement
{
    connectedCallback()
    {
        this.element = {}
        this.element.links = this.querySelectorAll('.main-policies-links-list-item');
        this.element.select = this.querySelector('.main-policies-links-select');

        this._selectHandler = (...args) => this._select(...args)

        this.element.select.addEventListener('change', this._selectHandler);
    }

    disconnectedCallback()
    {
        this.element.select.removeEventListener('change', this._selectHandler);
    }

    _select(e) {
        e.stopPropagation();

        const value = e.target.value
        if( e.target.getAttribute('selected') ) return;

        Array
            .from(this.element.links)
            .find(link => link.getAttribute('href').includes(value))
            ?.click()
    }
}

customElements.define('main-policies', MainPolicies)